<template>
    <div id="map"></div>
</template>

<script>
    import gMapStyleTaaf from './gmap-style'
    import gMapStyleRnn from './gmap-rnn-style'

    export default {
        props: ['lat', 'lng', 'zoom', 'static'],
        data() {
            return {
                googleMap: null,
                marker: null,
                staticParam: {
                    draggable: false,
                    zoomControl: false,
                    scrollwheel: false,
                    disableDefaultUI : true,
                    disableDoubleClickZoom: true,
                    draggableCursor: 'arrow'
                }
            };
        },
        computed: {},
        methods: {
            initMap() {
                let moreOption = null

                if (this.static){
                    moreOption = this.staticParam
                }

                var gMapStyle = null
                var icon = null

                if (window.taafljd.site === "taaf"){
                    gMapStyle = gMapStyleTaaf
                    icon = window.taafljd.iquitheme_assets + '/images/gmarker.png'
                }else{
                    gMapStyle = gMapStyleRnn
                    icon = window.taafljd.iquitheme_assets + '/images/gmarker-rnn.png'
                }

                var styledMapType = new google.maps.StyledMapType(gMapStyle,{name: 'Styled Map'})

                this.googleMap = new google.maps.Map(document.getElementById(this.$attrs.id), {
                    center: {
                        lat: this.lat,
                        lng: this.lng
                    },
                    zoom: this.zoom,
                    ... moreOption
                });

                this.googleMap.mapTypes.set('styled_map', styledMapType);
                this.googleMap.setMapTypeId('styled_map');


                this.marker = new google.maps.Marker({
                    position: {
                        lat: this.lat,
                        lng: this.lng
                    },
                    map: this.googleMap,
                    // title: value.label,
                    icon: icon
                });



            }
        },
        mounted() {
            this.initMap();
        },
    };
</script>